import React from 'react';
import ClearModal from '../../../ClearModal/ClearModal';

interface ConfirmModalProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  actionType: 'delete' | 'reopen' | 'deleteArchived';
}

const MODAL_CONFIGS = {
  delete: {
    title: 'Delete Active Record',
    bodyText: 'Are you sure you want to delete this active safety team record?'
  },
  reopen: {
    title: 'Reopen Record',
    bodyText: 'Are you sure you want to reopen this archived safety team record?'
  },
  deleteArchived: {
    title: 'Delete Archived Record',
    bodyText: 'Are you sure you want to permanently delete this archived safety team record?'
  }
};

const ConfirmModal: React.FC<ConfirmModalProps> = ({
  open,
  onClose,
  onConfirm,
  actionType
}) => {
  if (!actionType) {
    if (open) onClose();

    return null;
  }

  const { title, bodyText } = MODAL_CONFIGS[actionType];

  return (
    <ClearModal
      open={open}
      onClose={onClose}
      onConfirm={onConfirm}
      title={title}
      bodyText={bodyText}
    />
  );
};

export default ConfirmModal;
